import type { EquipmentSlotKey, EquipmentSlotType } from './types';

import hatIcon       from './assets/images/character/hat.png';
import glassesIcon   from './assets/images/character/sunglasses.png';
import maskIcon      from './assets/images/character/mask.png';
import jacketIcon    from './assets/images/character/jacket.png';
import tieIcon       from './assets/images/character/tie.png';
import torsoIcon     from './assets/images/character/torso.png';
import pantsIcon     from './assets/images/character/pants.png';
import shoesIcon     from './assets/images/character/shoes.png';
import glovesIcon    from './assets/images/character/gloves.png';
import armorIcon     from './assets/images/character/armor.png';
import necklaceIcon  from './assets/images/character/necklacke.png';
import watchIcon     from './assets/images/character/watch.png';
import phoneIcon     from './assets/images/character/bracelet.png';
import backpackIcon  from './assets/images/character/backpack.png';

export const SLOT_EQUIPMENT_TYPE: Record<EquipmentSlotKey, EquipmentSlotType> = {
  hat:          'hat',
  glasses:      'glasses',
  mask:         'mask',
  jacket:       'jacket',
  tie:          'tie',
  torso:        'torso',
  pants:        'pants',
  shoes:        'shoes',
  gloves:       'gloves',
  armor:        'armor',
  necklace:     'necklace',
  watch:        'watch',
  phone:        'phone',
  backpackSmall: 'bag',
  backpackLarge: 'bag',
};

export const SLOT_ICONS: Record<EquipmentSlotKey, string> = {
  hat:          hatIcon,
  glasses:      glassesIcon,
  mask:         maskIcon,
  jacket:       jacketIcon,
  tie:          tieIcon,
  torso:        torsoIcon,
  pants:        pantsIcon,
  shoes:        shoesIcon,
  gloves:       glovesIcon,
  armor:        armorIcon,
  necklace:     necklaceIcon,
  watch:        watchIcon,
  phone:        phoneIcon,
  backpackSmall: backpackIcon,
  backpackLarge: backpackIcon,
};
